(function() {
  'use strict';

  // ---------------------------------------------------------------------------
  // STOREFRONT: Force "Find a Store" text (Locally replaces with "Find it Locally" on hydrate)
  // ---------------------------------------------------------------------------
  var FIND_A_STORE = 'Find a Store';
  var FIND_IT_LOCALLY = 'Find it Locally';

  function forceFindAStoreText() {
    var containers = document.querySelectorAll('.buybox-block--locally [data-locally-compact]');
    for (var i = 0; i < containers.length; i++) {
      var trigger = containers[i].querySelector('#lcly-button-buy, a.lcly-primary-trigger');
      if (trigger && (trigger.textContent.indexOf(FIND_IT_LOCALLY) !== -1 || trigger.innerText.indexOf(FIND_IT_LOCALLY) !== -1)) {
        trigger.textContent = FIND_A_STORE;
      }
    }
  }

  function startFindAStoreObserver() {
    var containers = document.querySelectorAll('.buybox-block--locally [data-locally-compact]');
    for (var i = 0; i < containers.length; i++) {
      var obs = new MutationObserver(forceFindAStoreText);
      obs.observe(containers[i], { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      forceFindAStoreText();
      setTimeout(forceFindAStoreText, 500);
      setTimeout(forceFindAStoreText, 1500);
      startFindAStoreObserver();
    });
  } else {
    forceFindAStoreText();
    setTimeout(forceFindAStoreText, 500);
    setTimeout(forceFindAStoreText, 1500);
    startFindAStoreObserver();
  }

  // Guard: Theme Editor logic below (snapshot/restore only in designMode)
  if (!window.Shopify || !Shopify.designMode) return;
  
  const DEBUG = false;
  const DELAYS = [0, 50, 250, 800, 1500];
  
  function schedule(fn) {
    DELAYS.forEach(function(delay) {
      setTimeout(fn, delay);
    });
  }
  
  // ============================================================================
  // SECTION A: Locally Snapshot/Restore + Hide Loading Placeholder
  // ============================================================================
  
  window.__locallyPreservedHtml = null;
  
  function isLocallyHydrated(container) {
    if (!container) return false;
    const button = container.querySelector('#lcly-button-0');
    if (!button) return false;
    
    const hasIframe = button.querySelector('iframe');
    const hasModal = button.querySelector('[class*="modal"], [class*="overlay"], [id*="modal"]');
    const hasLocallyClasses = button.className && (
      button.className.includes('lcly') || 
      button.className.includes('locally') ||
      button.getAttribute('class') !== 'lcly-button-0'
    );
    const hasExtraContent = button.children.length > 1 || 
                           button.querySelector('span') ||
                           button.querySelector('div:not(#lcly-button-0)');
    
    return hasIframe || hasModal || hasLocallyClasses || hasExtraContent;
  }
  
  function snapshotLocally() {
    const containers = document.querySelectorAll('[data-locally-preserve]');
    for (let i = 0; i < containers.length; i++) {
      const container = containers[i];
      const rect = container.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) continue;
      
      if (isLocallyHydrated(container)) {
        window.__locallyPreservedHtml = container.innerHTML;
        if (DEBUG) console.debug('[Locally] Snapshot captured', container.innerHTML.length, 'chars');
        return true;
      }
    }
    return false;
  }
  
  function restoreLocally(sectionEl) {
    if (!sectionEl || !window.__locallyPreservedHtml) return false;
    
    const container = sectionEl.querySelector('[data-locally-preserve]');
    if (!container || isLocallyHydrated(container)) return false;
    
    container.innerHTML = window.__locallyPreservedHtml;
    if (DEBUG) console.debug('[Locally] HTML restored in section', sectionEl.id);
    return true;
  }
  
  function hideLocallyLoading(root) {
    if (!root) root = document;
    const preserveWrappers = root.querySelectorAll('[data-locally-preserve]');
    preserveWrappers.forEach(function(wrap) {
      const loading = wrap.querySelector('[data-locally-loading]');
      if (!loading) return;
      
      const hydrated =
        wrap.querySelector('#lcly-button-buy') ||
        wrap.querySelector('.lcly-pl-widget-parent') ||
        wrap.querySelector('a.lcly-primary-trigger') ||
        (wrap.querySelector('style') && wrap.querySelector('style').textContent.includes('lcly-primary-trigger'));
      
      if (hydrated) loading.remove();
    });
  }
  
  let loadingObserver = null;
  let observerTimeout = null;
  
  function startLoadingObserver() {
    if (loadingObserver) {
      loadingObserver.disconnect();
      loadingObserver = null;
    }
    if (observerTimeout) {
      clearTimeout(observerTimeout);
      observerTimeout = null;
    }
    
    loadingObserver = new MutationObserver(function() {
      if (observerTimeout) clearTimeout(observerTimeout);
      observerTimeout = setTimeout(hideLocallyLoading, 100);
    });
    
    loadingObserver.observe(document.body, { childList: true, subtree: true });
    
    setTimeout(function() {
      if (loadingObserver) {
        loadingObserver.disconnect();
        loadingObserver = null;
      }
    }, 2000);
  }
  
  function handleLocallyEvent(event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    
    const sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (!sectionEl) return;
    
    const hasLocally = sectionEl.querySelector('[data-locally-preserve]');
    if (!hasLocally) return;
    
    setTimeout(snapshotLocally, 0);
    schedule(function() {
      restoreLocally(sectionEl);
    });
  }
  
  function handleLocallyLoadEvent(event) {
    const sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    
    const sectionEl = document.getElementById('shopify-section-' + sectionId);
    if (!sectionEl) return;
    
    schedule(function() {
      restoreLocally(sectionEl);
    });
  }
  
  function handleLoadingHideEvent() {
    schedule(hideLocallyLoading);
    startLoadingObserver();
  }
  
  // ============================================================================
  // SECTION B: Prime Promise Snapshot/Restore
  // ============================================================================
  
  window.__primePromiseSnapshot = null;
  
  function isSafe(el) {
    if (!el) return false;
    return !el.querySelector('button[data-add-to-cart]') &&
           !el.querySelector('form[action*="/cart/add"]') &&
           !el.querySelector('[data-shopify-payment-terms]') &&
           !el.querySelector('.shopify-payment-button') &&
           !el.querySelector('[name="add"]');
  }
  
  function getPrimePromiseNode() {
    const wc = document.querySelector('delivery-promise-wc');
    if (!wc) return null;
    
    const candidates = [
      wc.closest('.AmazonLayout__amazon-layout'),
      wc.closest('.PromiseShell__ShopPromise-Shell'),
      wc.closest('.ContainerCommon__Container'),
      wc
    ].filter(Boolean);
    
    for (let i = 0; i < candidates.length; i++) {
      if (isSafe(candidates[i])) return candidates[i];
    }
    
    return wc;
  }
  
  function snapshotPrimePromise() {
    if (window.__primePromiseSnapshot) return;
    
    const node = getPrimePromiseNode();
    if (!node) return;
    
    const rect = node.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return;
    
    window.__primePromiseSnapshot = node.outerHTML;
    if (DEBUG) console.debug('[PrimePromise] Snapshot captured', node.outerHTML.length, 'chars');
  }
  
  function restorePrimePromise() {
    const slot = document.querySelector('[data-prime-promise-preserve]');
    if (!slot) return;
    
    if (document.querySelector('delivery-promise-wc')) {
      if (slot.querySelector('delivery-promise-wc')) slot.innerHTML = '';
      return;
    }
    
    if (!window.__primePromiseSnapshot) return;
    
    slot.innerHTML = window.__primePromiseSnapshot;
    if (DEBUG) console.debug('[PrimePromise] HTML restored');
  }
  
  function primePromiseTick() {
    snapshotPrimePromise();
    if (!document.querySelector('delivery-promise-wc')) {
      restorePrimePromise();
    }
    if (DEBUG) {
      console.debug('[PrimePromise]', {
        hasWC: !!document.querySelector('delivery-promise-wc'),
        hasSnapshot: !!window.__primePromiseSnapshot
      });
    }
  }
  
  function handlePrimePromiseEvent() {
    schedule(primePromiseTick);
  }
  
  // ============================================================================
  // SECTION C: Wire-up Theme Editor Events
  // ============================================================================
  
  const EDITOR_EVENTS = ['shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'];
  
  // Locally preserve listeners
  EDITOR_EVENTS.forEach(function(evt) {
    document.addEventListener(evt, handleLocallyEvent);
  });
  document.addEventListener('shopify:section:load', handleLocallyLoadEvent);
  
  // Loading hide listeners
  EDITOR_EVENTS.forEach(function(evt) {
    document.addEventListener(evt, handleLoadingHideEvent);
  });
  document.addEventListener('shopify:section:load', handleLoadingHideEvent);
  
  // Prime promise listeners
  EDITOR_EVENTS.forEach(function(evt) {
    document.addEventListener(evt, handlePrimePromiseEvent);
  });
  document.addEventListener('shopify:section:load', handlePrimePromiseEvent);
  
  // Initial execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(hideLocallyLoading, 200);
      setTimeout(hideLocallyLoading, 800);
      startLoadingObserver();
    });
  } else {
    setTimeout(hideLocallyLoading, 200);
    setTimeout(hideLocallyLoading, 800);
    startLoadingObserver();
  }
  
  // Periodic snapshots
  setInterval(function() {
    if (!window.__locallyPreservedHtml) snapshotLocally();
  }, 2000);
  
  setInterval(function() {
    if (!window.__primePromiseSnapshot) snapshotPrimePromise();
  }, 1200);
})();
